import { gql } from '@apollo/client'

export const CANCEL_RESERVATION_TA_PANEL_MUTATION = gql`
  mutation CancelReservationTAPanel(
    $dryRun: String!
    $reservationNumber: String!
    $cancelReason: String!
    $cancellationPolicyOverridden: Boolean
    $overriddenCancellationPenalty: Float
  ) {
    cancelReservationTAPanel(
      dryRun: $dryRun
      reservationNumber: $reservationNumber
      cancelReason: $cancelReason
      cancellationPolicyOverridden: $cancellationPolicyOverridden
      overriddenCancellationPenalty: $overriddenCancellationPenalty
    ) {
      description
      info {
        currency
        originalAmount
        penalty
        ratePlanCode
        displayRatePlanCode
        roomTypeCode
        displayRoomTypeCode
        roomTypeName
      }
      reservationNumber
      status
    }
  }
`
export const CANCEL_RESERVATION_TA_PANEL_PREVIEW_QUERY = gql`
  query CancelReservationTAPanelPreview($reservationNumber: String!) {
    cancelReservationTAPanelPreview(reservationNumber: $reservationNumber) {
      roomTypeName
      roomTypeCode
      displayRoomTypeCode
      ratePlanName
      ratePlanCode
      displayRatePlanCode
      guests {
        name
        email
        mobile
      }
      numberOfGuests
      numberOfExtrabeds
      numberOfChildren
      checkIn
      checkOut
      status
      oldPrice
      currentPrice
      currency
      penalty
      payable
    }
  }
`
